import React from 'react';
import { useDispatch } from 'react-redux';
import { updateLastLocation, clearLastLocation } from '../redux/actions/session/sessionActions';

interface UseLastLocationIdReturns {
  update: (locationId: string) => void;
  clear: () => void;
}

/**
 * Use this hook's return values to fetch, update, or clear the last selected
 * location ID. Operates on the :locationID URL parameter.
 */
const useLastLocationId = (): UseLastLocationIdReturns => {
  const dispatch = useDispatch();

  const update = React.useCallback(
    (locationId: string) => {
      dispatch(updateLastLocation({ locationId }));
    },
    [dispatch]
  );

  const clear = React.useCallback(() => {
    dispatch(clearLastLocation());
  }, [dispatch]);

  return {
    update,
    clear,
  };
};

export default useLastLocationId;
